const DEFAULT_PAYMENT_METHODS = [
  { id: "paypal", name: "PayPal" },
  { id: "mypos", name: "MyPos" },
];

const createPaymentMethodId = () => `payment_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

function slugifyPaymentMethod(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 64);
}

export function normalizePaymentMethods(value) {
  const rawMethods = Array.isArray(value) ? value : [];
  const seenIds = new Set();

  const normalized = rawMethods
    .map((method) => {
      const name = String(method?.name || "").trim();
      const id = slugifyPaymentMethod(method?.id || name);

      if (!name || !id || seenIds.has(id)) {
        return null;
      }

      seenIds.add(id);
      return { id, name };
    })
    .filter(Boolean);

  return normalized;
}

export function createPaymentMethod() {
  return {
    id: createPaymentMethodId(),
    name: "",
  };
}

export { DEFAULT_PAYMENT_METHODS };
